import GeoLocationService from './GeoLocationService';
import DMAStorageService from './DMAStorageService';
import { getCookie, setCookie } from 'helpers/VanillaCookie';
import { fetchData } from '../video/shared/smart-tag-adapter/network-tools';
import Domain from '../helpers/Domain';

export default class DMAService {
    constructor() {
        this.GeoLocation = new GeoLocationService();
        this.DMAStorage = new DMAStorageService();
        this.location = null;
        this.currentLocation = this.DMAStorage.getCurrentLocation();
        let [dma, stationId] = this.DMAStorage.getDMAStationIdStringOnNow();
        this.dma = dma;
        this.stationId = stationId;
    }

    updateLocation() {
        let loc = {
            lat: this.location.coords.latitude,
            lon: this.location.coords.longitude,
        };
        this.DMAStorage.setCurrentLocation(loc);
        this.DMAStorage.removeStorageDMA();
        this.deleteCookie('dmaInfo');
    }

    async getDMA(useFallback = false) {
        try {
            let obj;
            this.location = await this.GeoLocation.fetchLocation(useFallback);
            let cookieDma = getCookie('dmaInfo');

            if (
                Domain.isInternational() ||
                this.currentLocation == null ||
                this.currentLocation.lat != this.location.coords.latitude ||
                this.currentLocation.lon != this.location.coords.longitude
            ) {
                this.updateLocation();
                this.dma = null;
            }

            if (Domain.isInternational()) {
                obj = {
                    dma: 0,
                    stationId: this.stationId ? this.checkStationValue(this.stationId) : '',
                    latitude: this.location.coords.latitude,
                    longitude: this.location.coords.longitude,
                };

                return obj;
            }

            if (this.dma === null || this.dma !== cookieDma) {
                this.DMAStorage.removeStorageDMA();
                this.deleteCookie();
                const resultData = await this.getDmaFromSource();

                if (resultData.result.dmas) {
                    this.parseResult(resultData);
                    obj = {
                        dma: this.dma ? this.checkDMAValue(this.dma) : 0,
                        stationId: this.stationId ? this.checkStationValue(this.stationId) : '',
                        latitude: this.location.coords.latitude,
                        longitude: this.location.coords.longitude,
                    };
                    this.saveCookie(obj);
                    return obj;
                } else {
                    this.dma = null;
                    this.stationId = null;
                }
            }

            obj = {
                dma: this.dma ? this.checkDMAValue(this.dma) : 0,
                stationId: this.stationId ? this.checkStationValue(this.stationId) : '',
                latitude: this.location.coords.latitude,
                longitude: this.location.coords.longitude,
            };

            return obj;
        } catch (error) {
            console.log('ERROR', error);
        }
    }

    saveCookie(dmaInfo) {
        if (dmaInfo && dmaInfo.dma && dmaInfo.dma !== null) {
            setCookie('dmaInfo', dmaInfo.dma, {
                path: '/',
                expires: new Date(Date.now() + 24 * 60 * 60 * 1000),
            });
        }
    }

    deleteCookie() {
        setCookie('dmaInfo', '', {
            path: '/',
            expires: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000),
        });
    }

    checkDMAValue(dmaValue) {
        if (dmaValue === '') {
            dmaValue = 0;
        }
        return dmaValue;
    }

    checkStationValue(stationValue) {
        if (stationValue !== '') {
            let stationArray = [...new Set(stationValue.split(','))];
            stationValue = stationArray[0];
        } else {
            stationValue = null;
        }

        return stationValue;
    }

    parseResult(resultData) {
        let storageDma = [];
        let paramsDmas = [];
        let paramsStationIds = [];
        resultData.result.dmas.forEach((dma) => {
            paramsDmas.push(dma.dma);
            paramsStationIds.push(dma.stationId);
            storageDma.push({
                dma: dma.dma,
                stationId: dma.stationId,
                stationSlug: dma.callSignId,
                playbackUrl: dma.tokenDetails.playback_url,
            });
        });

        const uniqueDmas = [...new Set(paramsDmas)];
        const uniqueStationIds = [...new Set(paramsStationIds)];

        this.DMAStorage.setStorageDMA(storageDma);

        this.dma = uniqueDmas[0];
        this.stationId = uniqueStationIds[0];
    }

    getDmaAndStationId() {
        return this.getDMA().then(() => this.DMAStorage.getDMAStationIdStringOnNow());
    }

    /**
     * Extracts the first DMA value if multiple values are present.
     * @param {Object} dmaObject - The DMA object containing the DMA string.
     * @returns {string} - The first DMA value from comma separated values '502,522' or '0' if the DMA object is falsy.
     */
    getFirstDmaValue(dma) {
        if (!dma) return '0';
        return dma.includes(',') ? dma.split(',')[0] : dma;
    }

    async getDmaFromSource(isLTSEnabled = false) {
        let obj = {};
        let response = await fetchData(
            CBS.Registry.region.prefix +
                '/live-tv/dma/' +
                this.location.coords.latitude +
                '/' +
                this.location.coords.longitude +
                '/' +
                '?isLTSEnabled=' +
                isLTSEnabled,
        );

        return await response.json();
    }

    async getRefreshedTokenFromDma(isLTSEnabled = false) {
        this.location = await this.GeoLocation.fetchLocation(false);
        const response = await this.getDmaFromSource(isLTSEnabled);
        if (response?.result?.dmas) {
            const dmaObj = response.result.dmas[0];
            return {
                success: true,
                dma: dmaObj.dma ?? 0,
                stationId: dmaObj.stationId ?? '',
                callSignId: dmaObj.callSignId ?? '',
                assetURL: dmaObj.tokenDetails.playback_url ?? '',
                tokenExpirationTime: dmaObj.tokenDetails.tokenExpirationTime ?? null,
            };
        } else {
            return { success: false };
        }
    }
}
